import React from 'react'
import { IconWrapper, Circle } from './styles'

interface TelegramIconProps {
  disabled?: boolean
}

export const TelegramIcon = (props: TelegramIconProps) => {
  const { disabled } = props
  return (
    <IconWrapper disabled={disabled}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8868 6.79451L0.816518 0.241384C0.763393 0.214821 0.702456 0.208571 0.644643 0.222634C0.511831 0.255446 0.429018 0.389821 0.46183 0.524196L1.80871 6.02732C1.82902 6.11013 1.88996 6.17732 1.97121 6.20388L4.27902 6.99607L1.97277 7.78826C1.89152 7.81638 1.83058 7.88201 1.81183 7.96482L0.46183 13.4758C0.447768 13.5336 0.454018 13.5945 0.480581 13.6461C0.541518 13.7695 0.691518 13.8195 0.816518 13.7586L13.8868 7.24295C13.9353 7.21951 13.9743 7.17888 13.9993 7.13201C14.0603 7.00701 14.0103 6.85701 13.8868 6.79451ZM2.00246 11.9101L2.78839 8.69763L7.40089 7.11482C7.43683 7.10232 7.46652 7.0742 7.47902 7.0367C7.50089 6.97107 7.46652 6.90076 7.40089 6.87732L2.78839 5.29607L2.00558 2.09607L11.8181 7.01638L2.00246 11.9101Z"
          fill="black"
          fillOpacity="0.88"
        />
      </svg>
    </IconWrapper>
  )
}
